import { render, staticRenderFns } from "./SuggestionsPopup.vue?vue&type=template&id=e15f3154&scoped=true"
import script from "./SuggestionsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionsPopup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SuggestionsPopup.vue?vue&type=style&index=0&id=e15f3154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15f3154",
  null
  
)

export default component.exports